import React from 'react';
import useGetUtmParams from '../../../hooks/useGetUtmParams';
import { useResponsiveEffect } from '../../../hooks';
import withStore from '../../withStore';

import Footer from './Footer';

const FooterContainer = () => {
  const { desktop } = useResponsiveEffect();
  const utmParams = useGetUtmParams();
  return !desktop ? null : (
    <Footer utmParams={utmParams} />
  );
};

export default withStore(FooterContainer);
